import {
  type BudgetConfig,
  CloudAnalyticsModel,
  type CloudAnalyticsModelBudgetModel,
  Roles,
} from "@doitintl/cmp-models";
import { getCollection, type ModelReference, modelServerTimestamp } from "@doitintl/models-any";
import { modelDeleteField } from "@doitintl/models-any";
import { type AxiosInstance } from "axios";

import { type Customer } from "../../../types";
import { NoReplyEmail } from "./shared";

export const deleteManyBudgets = async (api: AxiosInstance, customerId: string, budgetIds: string[]) => {
  await api.delete(`/v1/customers/${customerId}/analytics/budgets/deleteMany`, { data: { ids: budgetIds } });
};

export const updateBudget = async ({
  ref,
  name,
  description,
  config,
}: {
  name: string;
  description: string;
  config: BudgetConfig;
  ref: ModelReference<CloudAnalyticsModelBudgetModel>;
}) => {
  await ref.update({
    name,
    description,
    config,
    timeModified: modelServerTimestamp(),
    draft: false,
  });
};

export const createNewBudget = async ({
  name,
  description,
  config,
  email,
  customer,
}: {
  name: string;
  description: string;
  config: BudgetConfig;
  email: string;
  customer: Customer;
}) => {
  const ref = getCollection(CloudAnalyticsModel).doc("budgets").collection("cloudAnalyticsBudgets").newDoc();

  await ref.set({
    customer: customer.ref,
    name,
    description,
    config,
    public: null,
    collaborators: [
      {
        email,
        role: Roles.OWNER,
      },
    ],
    recipients: customer.presentationMode?.isPredefined ? [NoReplyEmail] : [email],
    recipientsSlackChannels: [],
    timeCreated: modelServerTimestamp(),
    timeModified: modelServerTimestamp(),
    isValid: true,
  });

  return ref;
};

export const updateBudgetSubscriptions = async (
  api: AxiosInstance,
  customerId: string,
  budgetId: string,
  newRecipients: string[]
) => {
  await getCollection(CloudAnalyticsModel).doc("budgets").collection("cloudAnalyticsBudgets").doc(budgetId).update({
    recipients: newRecipients,
  });
  await api.patch(`/v1/customers/${customerId}/analytics/budgets/${budgetId}/update-enforced-by-metering`);
};

export const deleteBudgetUtilizationAndData = async (budgetId: string) => {
  const timeModified = modelServerTimestamp();
  await getCollection(CloudAnalyticsModel).doc("budgets").collection("cloudAnalyticsBudgets").doc(budgetId).update({
    utilization: modelDeleteField(),
    data: modelDeleteField(),
    timeModified,
  });
};
